import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'global_announcement_dismissed_v1';

const AnnouncementBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      const val = localStorage.getItem(STORAGE_KEY);
      if (val === '1') setDismissed(true);
    } catch (_) {}
  }, []);

  const handleClose = () => {
    setDismissed(true);
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (_) {}
  };

  if (dismissed) return null;

  return (
    <div style={{
      background: '#2e7d32',
      color: '#fff',
      padding: '10px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'sticky',
      top: 62, // navbar height
      zIndex: 999
    }}>
      <div style={{
        maxWidth: 1200,
        width: '100%',
        fontSize: 14,
        lineHeight: 1.45,
        textAlign: 'center',
        paddingRight: 28
      }}>
        <strong>Important:</strong> Valve has released an <a href="https://help.steampowered.com/en/faqs/view/5E90-1DF8-AAF1-56F2" target="_blank" rel="noreferrer" style={{ color: '#fff', textDecoration: 'underline' }}>update</a> that introduces the ability to cancel trades within 7 days. We have already adjusted our trading mechanics on the website to comply with the new rules. The updated terms for buyers and sellers are described in detail in the <a href="/terms-and-conditions" style={{ color: '#fff', textDecoration: 'underline' }}>FAQ</a> section. Please make sure to review them before starting to trade.
      </div>
      <button onClick={handleClose} aria-label="Dismiss announcement" style={{
        position: 'absolute',
        right: 8,
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'transparent',
        border: 'none',
        color: '#fff',
        fontSize: 18,
        cursor: 'pointer'
      }}>
        ×
      </button>
    </div>
  );
};

export default AnnouncementBanner;


